<template>
  <div>
    <template v-if="schema.fields.length">
      <Breadcrumb class="p-mb-3" :home="home" :model="breadcrumbItems" />
      <Toast position="bottom-left" />

      <div class="panel-body">
        <form ref="form" @submit.prevent="submitForm" method="POST">
          <vue-form-generator
            :schema="schema"
            :model="model"
            :options="formOptions"
            @validated="onValidated"
          ></vue-form-generator>
          <br />
          <Button
            type="submit"
            :disabled="submiting || !isValid"
            class="p-button-success p-mr-2"
            >{{ !submiting ? "ذخیره اطلاعات" : "در حال ارسال" }}</Button
          >

          <router-link :to="`/List/${moduleName}`">
            <Button label=" بازگشت به لیست" class="p-button-outlined p-mr-1" />
          </router-link>
        </form>
      </div>
    </template>
    <template v-else>
      <ProgressBar mode="indeterminate" class="p-mt-5" />
    </template>
  </div>
</template>

<script>
import CrudService from "@/service/CrudService";
import "@/assets/layout/form-generator.scss";
import { getters } from "./../../store.js";
import VueFormGenerator from "vue-form-generator";
import resources from "./../../resources";
import formatter from "./formatter";
import helper from "../../helper";

export default {
  data() {
    return {
      isValid: false,
      moduleName: null,
      moduleLabel: null,
      home: { icon: "pi pi-home", to: "/" },
      breadcrumbItems: [],
      submiting: false,
      schema: { fields: [] },
      model: {
        Id: 0,
      },
      formOptions: {
        validateAfterLoad: true,
        validateAfterChanged: true,
        validateAsync: true,
      },
    };
  },
  crudService: null,
  watch: {
    $route(to) {
      this.crudService = new CrudService(to.params.module, this);
      this.moduleName = to.params.module;
      this.setBreadcrumb();
    },
  },
  computed: {
    ...getters,
  },
  methods: {
    onValidated(isValid) {
      this.isValid = isValid;
    },
    setBreadcrumb() {
      this.moduleLabel = this.modules.filter(
        (x) => x.name == this.moduleName
      )[0].label;
      this.breadcrumbItems = [];
      this.breadcrumbItems.push({
        label: this.moduleLabel,
        to: `/List/${this.moduleName}`,
      });
      this.breadcrumbItems.push({
        label: "درج",
        to: `/Create/${this.moduleName}`,
      });
    },

    async submitForm() {
      this.submiting = true;
      const object = formatter.reformModelBeforePost(this.model, this.schema);
      const result = await this.crudService.create(object);

      if (result > 0) {
        this.$router.push({ path: `/Edit/${this.moduleName}/${result}` });
      }

      helper.toastSubmitResult(result > 0,this.$toast);

      this.submiting = false;
    },
  },

  async created() {
    this.moduleName = this.$route.params.module;
    this.setBreadcrumb();

    this.crudService = new CrudService(this.moduleName, this);
    let fields = await this.crudService.getMetaData();

    formatter.setupCustomFields(fields);

    this.schema.fields = fields;

    let res = VueFormGenerator.validators.resources;
    for (const key in res)
      VueFormGenerator.validators.resources[key] = resources[key];
  },
};
</script>

<style lang="scss" scoped>
</style>

